type SortStaffOffToEndOptions = {
  /** Set staffId nghỉ cả ngày (full-day OFF) — xem getOffStaffIds */
  offIds: Set<string>;
  /** Bật sort: chỉ khi đã load đủ staff và không phải calendar trong modal */
  enabled: boolean;
  /** staffId được pin lên đầu tuyệt đối (vd staffFilter đang chọn) */
  pinnedId?: string;
};

/**
 * Đẩy các staff nghỉ cả ngày (OFF) xuống cuối danh sách, giữ nguyên thứ tự
 * tương đối của các nhóm. Staff còn lại (kể cả block hour 1 phần) giữ vị trí cũ.
 *
 * Stable: dùng forEach nên thứ tự gốc trong từng nhóm được bảo toàn.
 * Khi enabled=false trả về list nguyên trạng (đã có pin staffFilter sẵn từ caller).
 */
export const sortStaffOffToEnd = <T extends { id: string }>(
  list: T[],
  opts: SortStaffOffToEndOptions
): T[] => {
  if (!opts.enabled) return list;

  const pinned: T[] = [];
  const normal: T[] = [];
  const off: T[] = [];

  list.forEach((item) => {
    if (opts.pinnedId && item.id === opts.pinnedId) pinned.push(item);
    else if (opts.offIds.has(item.id)) off.push(item);
    else normal.push(item);
  });

  return [...pinned, ...normal, ...off];
};

export default sortStaffOffToEnd;
